import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed, set } from '@ember/object';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import displayRateParityFilters from 'lumen/helpers/display-rate-parity-filters';

interface SettingsReportsTablesCellsTdFiltersSignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdFilters extends Component<SettingsReportsTablesCellsTdFiltersSignature> {
  isHovered = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get filters() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.reportGroup?.filters;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotelOrMarket() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.reportGroup?.hotel?.id) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this.reportGroup?.hotel;
    }
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.reportGroup?.market;
  }

  @computed('args.cellData.{hotel,market}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reportGroup() {
    return this.args.cellData;
  }

  @action
  // @ts-expect-error: Incorrect type
  isCellHovered(isHovered): void {
    set(this, 'isHovered', isHovered);
  }

  <template>
    <div
      class="truncate"
      role="tooltip"
      {{on "mouseenter" (fn this.isCellHovered true)}}
      {{on "mouseleave" (fn this.isCellHovered false)}}
    >
      {{#if this.filters}}
        {{displayRateParityFilters this.filters this.hotelOrMarket}}
      {{/if}}
    </div>
    {{#if this.isHovered}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @tooltipClass="default-tooltip default-tooltip--large"
      >
        {{displayRateParityFilters this.filters this.hotelOrMarket}}
      </EmberTooltip>
    {{/if}}
  </template>
}
